module.exports = __webpack_public_path__ + "static/6-a4168804c6178e7b23dfea9c26eedeed.jpeg";